/*
 * BAUUNIVERSO — Primary Button Customizer con Open Sauce One Black.
 * Sostituisci il precedente script custom dei pulsanti con questo: NON caricarli insieme.
 * Richiede la dichiarazione @font-face 'Open Sauce One Black' nel CSS del tema.
 */
(function () {
  'use strict';

  const FONT = "'Open Sauce One Black', sans-serif";

  function createShineElement() {
    const shine = document.createElement('span');
    shine.className = 'button-shine-effect';
    shine.setAttribute('aria-hidden', 'true');
    shine.style.cssText = `
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(90deg, transparent 0%, rgba(0, 225, 255, 0.4) 50%, transparent 100%);
      pointer-events: none;
      transform: translate3d(0, 0, 0) skewX(-20deg);
      will-change: left;
      z-index: 1;
      animation: shineGradient 5s ease-in-out infinite;
      flex: 0 0 0px;
      overflow: visible;
      margin: 0;
      padding: 0;
    `;
    return shine;
  }

  function addShineAnimation() {
    if (document.getElementById('shine-animation-styles')) return;
    const style = document.createElement('style');
    style.id = 'shine-animation-styles';
    style.textContent = `
      @keyframes shineGradient {
        0% { left: -150%; }
        100% { left: 150%; }
      }
      .button-primary-custom > *:not(.button-shine-effect) {
        position: relative !important;
        z-index: 2 !important;
      }
      .button-shine-effect {
        flex: 0 0 0px !important;
        overflow: visible !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      /* Mantiene lo spostamento originale di 7px del testo buy-button. */
      .buy-buttons .button-primary-custom {
        padding-left: calc(40px + 7px) !important;
        padding-right: calc(40px - 7px) !important;
      }
      @media (min-width: 750px) {
        .buy-buttons .button-primary-custom {
          padding-left: calc(48px + 7px) !important;
          padding-right: calc(48px - 7px) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function setBlackTypography(el) {
    el.style.setProperty('font-family', FONT, 'important');
    el.style.setProperty('font-weight', '900', 'important');
    el.style.setProperty('letter-spacing', '-0.035em', 'important');
    el.style.setProperty('font-synthesis', 'none', 'important');
  }

  function applyCustomStyles(button) {
    if (button.classList.contains('button-primary-custom')) return;
    button.classList.add('button-primary-custom');

    const styles = {
      'background': 'linear-gradient(270deg, rgb(0, 162, 255) 0%, rgb(0, 81, 255) 100%)',
      'background-color': '#007AFF',
      'background-image': 'linear-gradient(270deg, rgb(0, 162, 255) 0%, rgb(0, 81, 255) 100%)',
      'color': '#ffffff',
      'border': '0',
      'outline': '0',
      'box-shadow': '0 4px 16px rgba(0, 162, 255, 0.3)',
      'position': 'relative',
      'overflow': 'hidden',
      'border-radius': '9999px',
      'transition': 'transform .25s ease, box-shadow .25s ease, filter .25s ease',
      'padding': '16px 40px',
      'font-family': FONT,
      'font-size': '22px',
      'font-weight': '900',
      'letter-spacing': '-0.035em',
      'font-synthesis': 'none',
      'line-height': '1.4',
      'display': 'inline-flex',
      'align-items': 'center',
      'justify-content': 'center',
      'text-align': 'center',
      'vertical-align': 'middle'
    };
    Object.keys(styles).forEach(prop => button.style.setProperty(prop, styles[prop], 'important'));

    /* Non cambiare font alle icone SVG / icon-font; solo al pulsante e ai suoi testi. */
    const textElements = [button, ...button.querySelectorAll('span, strong, em, b, small, .button__text, .button__label')]
      .filter(el => !el.closest('.button-shine-effect') && !el.closest('svg') && !el.matches('.icon, [class*="icon-"]'));
    textElements.forEach(el => {
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('font-size', '20px', 'important');
      setBlackTypography(el);
      el.style.setProperty('text-align', 'center', 'important');
      el.style.setProperty('vertical-align', 'middle', 'important');
    });

    if (!button.querySelector('.button-shine-effect')) {
      button.insertBefore(createShineElement(), button.firstChild);
    }

    if (button.closest('.buy-buttons')) {
      const desktop = window.innerWidth >= 750;
      button.style.setProperty('padding-left', (desktop ? 55 : 47) + 'px', 'important');
      button.style.setProperty('padding-right', (desktop ? 41 : 33) + 'px', 'important');
    }

    button.addEventListener('mouseenter', function () {
      this.style.setProperty('transform', 'translateY(-2px)', 'important');
      this.style.setProperty('filter', 'brightness(1.1)', 'important');
      this.style.setProperty('box-shadow', '0 6px 24px rgba(0, 162, 255, 0.4)', 'important');
    });
    button.addEventListener('mouseleave', function () {
      this.style.setProperty('transform', 'none', 'important');
      this.style.setProperty('filter', 'none', 'important');
      this.style.setProperty('box-shadow', '0 4px 16px rgba(0, 162, 255, 0.3)', 'important');
    });

    if (window.innerWidth >= 750) {
      button.style.setProperty('padding', '18px 48px', 'important');
      button.style.setProperty('font-size', '20px', 'important');
      textElements.forEach(el => el.style.setProperty('font-size', '20px', 'important'));
    }
  }

  const selector = `
    .button:not(.button--secondary):not(.button--outline):not(.button--subdued),
    button.button:not(.button--secondary):not(.button--outline):not(.button--subdued),
    a.button:not(.button--secondary):not(.button--outline):not(.button--subdued),
    button[name="add"],
    .product-form__submit,
    form[action*="/cart/add"] button[type="submit"],
    .shopify-payment-button__button--unbranded
  `;
  function customizePrimaryButtons(scope = document) {
    if (scope.nodeType === 1 && scope.matches(selector) && !scope.closest('.privacy-bar__inner')) {
      applyCustomStyles(scope);
    }
    scope.querySelectorAll(selector).forEach(button => {
      if (!button.closest('.privacy-bar__inner')) applyCustomStyles(button);
    });
  }

  function init() {
    addShineAnimation();
    customizePrimaryButtons();
    [500, 1000, 2000].forEach(delay => setTimeout(customizePrimaryButtons, delay));
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) customizePrimaryButtons(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', () => customizePrimaryButtons());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
